export type PauseReason = "manual" | "dialog" | "visibility";

interface TimerApi {
  setTimeout(callback: () => void, delay: number): number;
  clearTimeout(timer: number): void;
}

const browserTimer: TimerApi = {
  setTimeout: (callback, delay) => window.setTimeout(callback, delay),
  clearTimeout: (timer) => window.clearTimeout(timer),
};

export class RotationController {
  private timer: number | undefined;
  private readonly pauseReasons = new Set<PauseReason>();

  constructor(
    private readonly intervalMs: number,
    private readonly onRotate: () => void,
    private readonly timerApi: TimerApi = browserTimer,
  ) {}

  start(): void {
    this.schedule();
  }

  stop(): void {
    if (this.timer !== undefined) {
      this.timerApi.clearTimeout(this.timer);
      this.timer = undefined;
    }
  }

  pause(reason: PauseReason): void {
    this.pauseReasons.add(reason);
    this.stop();
  }

  resume(reason: PauseReason): void {
    this.pauseReasons.delete(reason);
    if (!this.isPaused()) {
      this.schedule();
    }
  }

  toggleManual(): boolean {
    if (this.pauseReasons.has("manual")) {
      this.resume("manual");
    } else {
      this.pause("manual");
    }
    return this.pauseReasons.has("manual");
  }

  isPaused(): boolean {
    return this.pauseReasons.size > 0;
  }

  isManuallyPaused(): boolean {
    return this.pauseReasons.has("manual");
  }

  private schedule(): void {
    this.stop();
    if (this.isPaused()) {
      return;
    }

    this.timer = this.timerApi.setTimeout(() => {
      this.timer = undefined;
      this.onRotate();
      this.schedule();
    }, this.intervalMs);
  }
}
